export const getDefaultAlbumArt = (source: 'spotify' | 'local'): string => {
  switch (source) {
    case 'spotify':
      return 'https://images.unsplash.com/photo-1611339555312-e607c8352fd7?w=400&auto=format&fit=crop&q=80';
    case 'local':
      return 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=400&auto=format&fit=crop&q=80';
    default:
      return 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=400&auto=format&fit=crop&q=80';
  }
};